import React from 'react';
import { Grid, IconButton, Typography } from '@mui/material';
import { COLOR_PRIMARY_2 } from 'src/colors';
import LockSharpIcon from '@mui/icons-material/LockSharp';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import UnavailableIcon from 'src/App/Components/Icons/UnavailableIcon';
import { POINTER_GREEN } from 'src/const';
import TooltipNew from '../Tooltips/TooltipNew';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const StatsCardSideModal = ({
  title,
  value,
  isDisabled,
  isListingRecentlyAdded,
  upgradeMessage,
  handleOnSampleClick,
  isMobileScreen,
  isAdrAnomaly,
  tooltipContent,
  onClose,
  setMarketUrlBack,
  handleOnLockIconCick
}: {
  title: string;
  value: string;
  isDisabled?: boolean;
  isListingRecentlyAdded: boolean;
  upgradeMessage: any;
  handleOnSampleClick: any;
  isMobileScreen: boolean;
  isAdrAnomaly: boolean;
  tooltipContent?: string | JSX.Element;
  onClose: any;
  setMarketUrlBack: () => void;
  handleOnLockIconCick?: any;
}) => {
  return (
    <Grid
      sx={{
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        alignIterms: 'center',
        justifyContent: 'flex-start',
        boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
        padding: '40px 20px',
        gap: '10px',
        borderRadius: '20px',
        width: isMobileScreen ? 'calc(100% - 20px)' : 'calc(50% - 10px)',
      }}
    >
      <Typography
        color="textSecondary"
        variant="subtitle2"
        sx={{
          fontSize: '16px',
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'center',
          gap: '0px',
        }}
      >
        {title}
        {tooltipContent && (
          <TooltipNew title={title} content={tooltipContent}>
            <IconButton>
              <InfoOutlinedIcon sx={{ fontSize: 18 }} />
            </IconButton>
          </TooltipNew>
        )}
      </Typography>

      <Typography color="textPrimary" variant="h6" sx={{ color: POINTER_GREEN, fontSize: '24px' }}>
        {!isDisabled ? (
          isListingRecentlyAdded ? (
            <AccessTimeIcon />
          ) : isAdrAnomaly && (title.includes('Revenue') || title.includes('Nightly')) ? (
            <UnavailableIcon />
          ) : (
            value
          )
        ) : (
          <LockSharpIcon
            sx={{ fontSize: 24, color: POINTER_GREEN, cursor: 'pointer' }}
            onClick={handleOnLockIconCick && handleOnLockIconCick}
          />
        )}
      </Typography>
      {isDisabled && upgradeMessage && (
        <Typography
          variant="body1"
          sx={{
            fontSize: '14px',
            fontWeight: 500,
            color: COLOR_PRIMARY_2,
            cursor: 'pointer',
            pointerEvents: 'auto',
            textDecoration: 'underline',
            maxWidth: '150px',
            textAlign: 'center',
            mt: 1,
          }}
          onClick={() => {
            onClose();
            setMarketUrlBack();
            handleOnSampleClick('expert');
          }}
        >
          {upgradeMessage}
        </Typography>
      )}
    </Grid>
  );
};

export default StatsCardSideModal;
